import { render, staticRenderFns } from "./AssessmentWait.vue?vue&type=template&id=1c7a551d"
import script from "./AssessmentWait.vue?vue&type=script&lang=ts"
export * from "./AssessmentWait.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports